/**
 * Bridges the BasicNet chatbot app's interaction tracking to the store's
 * custom web pixel.
 *
 * The chatbot app embed (basic-chatbot-prod) reports every interaction by
 * pushing `{ event: 'shopify_chatbot', chatbot_event, event_value_chatbot,
 * chat_id_hash256 }` onto `window.dataLayer` — main-document state a
 * sandboxed web pixel can never see. This republishes each of those entries
 * on the Shopify analytics bus as `bnt:bot_integration`, where the custom
 * pixel subscribes and forwards a GA4event (event_name "chatbot", specific
 * action in `label`) per the WebRanking Shopify Chatbot spec.
 *
 * `label` values are the app's own action names, which already match the
 * spec: chat_start, send_message, product_search, chatbot_quick_answer,
 * chat_reset.
 */

(() => {
  const dataLayer = (window.dataLayer = window.dataLayer || []);

  let forward = dataLayer.push.bind(dataLayer);

  const wrapper = (...entries) => {
    for (const entry of entries) {
      if (entry?.event === 'shopify_chatbot' && entry.chatbot_event) {
        window.Shopify?.analytics?.publish('bnt:bot_integration', {
          label: entry.chatbot_event,
          value: entry.event_value_chatbot ?? null,
          chat_id_hash256: entry.chat_id_hash256 ?? null,
        });
      }
    }
    return forward(...entries);
  };

  // GTM, should it ever load on the storefront document, replaces
  // `dataLayer.push` with its own processor without chaining to whatever was
  // installed before — a plain reassignment here would silently die that day.
  // The accessor keeps this wrapper first in line: later assignments land in
  // `forward` and the bridge stays in the chain.
  Object.defineProperty(dataLayer, 'push', {
    configurable: true,
    get: () => wrapper,
    set: (fn) => {
      forward = fn;
    },
  });
})();
